export default {
  manage_createEditKeyFob_EditTitle: "Edit Key Fob",
  manage_createEditKeyFob_CreateTitle: "Create new Key Fob",
  manage_createEditKeyFob_success: "Key Fob was created successfully",
  manage_createEditKeyFob_success_edit: "Key Fob was edited successfully",
  manage_createEditKeyFob_HexInputLabel: "Key Fob",
  manage_createEditKeyFob_HexInputPlaceholder: "Key Fob",
  manage_createEditKeyFob_DriverInputLabel: "Driver",
  manage_createEditKeyFob_DriverInputPlaceholder: "Driver",
  manage_createEditKeyFob_duplicatedKeyFobErrorMessage: "This Key Fob already exists or the driver already has a key fob assigned",
  manage_createEditKeyFob_infoBluetooth: "Geometris Bluetooth KeyFob IDs cannot be edited"
};
